import React, { useState } from "react";
import Footer from "../components/footer/Footer";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import CaseStudyTabs from "../components/case-study-tabs/CaseStudyTabs";

const CaseStudies = () => {
  const { t } = useTranslation("caseStudiesPage");
  const pageBanner = t("caseStudyBanner", { returnObjects: true });
  const caseStudiesContent = t("caseStudies", { returnObjects: true });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });

  const [allCaseStudies, setAllCaseStudies] = useState(false);
  const visibleCaseStudies = allCaseStudies
    ? caseStudiesContent?.cardsData
    : caseStudiesContent?.cardsData?.slice(0, 6);

  return (
    <>
      <MegaMenu />
      <ServicesPageBanner
        shortHeading="Our Case Studies"
        mainHeading="Driving Business Growth Through Proven Solutions"
        description="Explore how our tailored solutions have empowered businesses to overcome challenges, drive growth, & achieve measurable outcomes."
      />
      <CaseStudyTabs />
      <SoftwareCompanyCta content={footerCtaContent} />
      <Footer />
    </>
  );
};

export default CaseStudies;
